/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ContactData
 */
export interface ContactData {
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    website: string;
    /**
     * 
     * @type {string}
     * @memberof ContactData
     */
    $type?: ContactDataTypeEnum;
}


/**
 * @export
 */
export const ContactDataTypeEnum = {
    PtwPtw100BeamConstancyCheckCoreContactDataPtwPtw100BeamConstancyCheckCore: 'Ptw.Ptw100.BeamConstancyCheck.Core.ContactData, Ptw.Ptw100.BeamConstancyCheck.Core'
} as const;
export type ContactDataTypeEnum = typeof ContactDataTypeEnum[keyof typeof ContactDataTypeEnum];


/**
 * Check if a given object implements the ContactData interface.
 */
export function instanceOfContactData(value?: unknown): value is ContactData {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ContactDataTypeEnum)[0];
}

export function ContactDataFromJSON(json: any): ContactData {
    return ContactDataFromJSONTyped(json, false);
}

export function ContactDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'street': json['street'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'phone': json['phone'],
        'email': json['email'],
        'website': json['website'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ContactDataToJSON(value?: ContactData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'street': value.street,
        'zipCode': value.zipCode,
        'city': value.city,
        'country': value.country,
        'phone': value.phone,
        'email': value.email,
        'website': value.website,
        '$type': value.$type,
    });
}

